import { Component, inject } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { SessionBootstrapService } from './services/session-bootstrap.service';

@Component({
  selector: 'app-global-spinner',
  template: `
    @if (
      (authService.loading$ | async) ||
      sessionBootstrap.isActive() ||
      authService.isCacheApiLoading()
    ) {
      <div class="spinner-overlay">
        <mat-progress-spinner [diameter]="50" mode="indeterminate"></mat-progress-spinner>
      </div>
    }
  `,
  imports: [MatProgressSpinnerModule, CommonModule],
  standalone: true,
  styles: [`
    .spinner-overlay {
      position: fixed;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.45);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 999999;
    }
  `],
})
export class GlobalSpinnerComponent {
  readonly authService = inject(AuthService);
  readonly sessionBootstrap = inject(SessionBootstrapService);
}
